import { $Q } from './query-selector';

const toggleContainer = (elementShow, elementhidden) => {
  $Q(elementShow).dataset.active = true;
  $Q(elementhidden).dataset.active = false;
};

export function recoverToggle() {
  if (!$Q('#display-recover') || !$Q('#recover-hidden')) return;

  $Q('#display-recover').addEventListener('click',
    () => toggleContainer('#recover-container', '#login-container'),
  );

  $Q('#recover-hidden').addEventListener('click',
    () => toggleContainer('#login-container', '#recover-container'),
  );
}
